/* eslint-env browser */

// Feature: encode a form as URLSearchParams (form urlencoding, but better)

var formtourlsearchparams = function (form) {
  var params = new URLSearchParams()
  Array.from(form.elements)
    .filter(function (i) { return !i.disabled && i.name && (!/checkbox|radio/.test(i.type) || i.checked) })
    .map(function (field) {
      return field.options
        ? Array.from(field.options).map(function (i) { return i.selected && params.append(field.name, i.value) })
        : params.append(field.name, form[field.name].type === 'file' ? '' : field.value)
    })
  return params
}

module.exports = formtourlsearchparams
